<!------------------------------------------------------------------------------
  Copyright (c) 2019. Keni Williams <kenneth.williams@estuk.co.uk>

  This file BaseButton.vue is part of event_pass_client.dev.
  Unauthorized copying of this file, via any medium is strictly prohibited.
  Proprietary and confidential
  BaseButton.vue can not be copied and/or distributed
  without the express permission of Keni Williams <kenneth.williams@estuk.co.uk>
  ----------------------------------------------------------------------------->

<template>
    <component :is="component_type"
               v-on:click="click"
               class="btn waves-effect waves-light"
               :class="[
            {
            'btn-small':small,
            'btn-sm':small
            },
            cls,
            btn_type
            ]"
    >
        <slot></slot>
    </component>
</template>

<script>
    export default {
        name: "BaseButton",
        props: {
            cls: String | Object,
            small: {
                type: String | Boolean,
                default: false
            },
            btn_type: {
                type: String,
                default: 'btn-primary'
            },
            title: {
                type: String
            },
            type: {
                type: String,
                default: 'button'
            },
            tooltip: {
                type: Boolean,
                default: true
            }
        },
        data() {
            return {
                component_type: this.type || 'button'
            }
        },
        methods:{
          click(){
              this.$emit('click')
          }
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// app/Shared/Resources/Assets/js/components/base/buttons/BaseButton.vue